import { takeLatest, call, put } from 'redux-saga/effects';
import { DELETE_PORTOFOLIO_START, DELETE_PORTOFOLIO_ERROR, DELETE_PORTOFOLIO_SUCCESS, GET_PORTOFOLIO_START } from '../../types';

import apiCall from '../../../api/apiGet';

export function* del({ payload }) {
  try {
    const url = `/portofolio/delete/${payload.id}`;
    const method = 'DELETE';
    const headers = {Authorization: `Bearer ${payload.token}`};
    const results = yield call(apiCall, url, method, headers);
    console.log(results)
    yield put({ type: DELETE_PORTOFOLIO_SUCCESS, results: results.data });
  } catch (error) {
    console.log(error)
    yield put({ type: DELETE_PORTOFOLIO_ERROR, error });
  } finally {
    yield put({ type: GET_PORTOFOLIO_START, payload: {lang: null, token: payload.token} });
    payload.navigate(-1);
  }
}

export default function* delete_portofolio() {
  yield takeLatest(DELETE_PORTOFOLIO_START, del);
}
